<div class="modal-content">
    <div class="modal-header model_center_header">
        <h5 class="modal-title">Advanced Search</h5>
        <button type="button" (click)="dismissModal()" class="close model_close_btn" data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true" class="model_close_btn" title="close">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="search_panel">
            <mat-radio-group aria-label="Select an option">
              <mat-radio-button value="2" (click)="changeAdvanceSeachRadio('all')" class="mr-2" checked="true">All
              </mat-radio-button>
                <mat-radio-button value="1" (click)="changeAdvanceSeachRadio('favourite')" class="mr-2">Favourites
                </mat-radio-button>
                  <mat-radio-button value="1" (click)="changeAdvanceSeachRadio('historical')" class="mr-2">Historical Data
                </mat-radio-button>
            </mat-radio-group>
            <div [formGroup]="frmAdvanceSearchColumns" *ngIf="frmAdvanceSearchColumns">
                <div class="row mt-2">
                    <div *ngFor="let field of advanceSearchColumns" class="col-lg-2">
                        <mat-form-field>
                            <input matInput [placeholder]="field" [formControlName]="field">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-2">
                        <button class="btncss me-2 btn_primary btn_thin" (click)="getAdvanceSearchData()">Search</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid_panel">
            <app-basic-gridview *ngIf="advanceSearchGridData.length>0" [lstData]="advanceSearchGridData"
                [columnsToHide]="advanceSearchColumnsToHide" [gridTitle]=""
                [showExcelDownloadOption]="false" [showSearchOption]="false" [showRecordsPerPageOption]="true"
                [showPagination]="true" (cellClickEvent)="advanceSearchCellClick($event)"></app-basic-gridview>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btncss me-2 btn_primary" (click)="submitAdvanceSearchResult()">Submit</button>
        <button class="btncss me-2 btn_secondary" (click)="dismissModal()">Close</button>
    </div>
</div>